import {IWebsiteSidebarItem, WebsiteSidebarItem} from "../website-sidebar-item.model";
import {ActionEmitterService} from "../../../shared/services/action-emitter.service";

export interface IWebsiteSidebarSimpleItem extends IWebsiteSidebarItem {
  notification?: boolean;
  beta?: boolean;
  path?: string;
  externalLink?: boolean;
  showUpgrade?: boolean;
  advanced?: boolean;

  setActions: (actions: string[]) => void;
  emitActions: () => void;
}

export class WebsiteSidebarSimpleItem extends WebsiteSidebarItem implements IWebsiteSidebarSimpleItem {
  public path?: string;
  public override notification?: boolean;
  public override beta?: boolean;
  private actions?: string[];
  public externalLink?: boolean;
  public showUpgrade?: boolean;
  public advanced?: boolean;

  constructor(
    name: string,
    label: string,
    img?: string,
    icon?: string,
    path?: string,
    actions?: string[],
    disabled?: boolean,
    hidden?: boolean,
    notification?: boolean,
    beta?: boolean,
    externalLink?: boolean,
    showUpgrade?: boolean,
    advanced?: boolean
  ) {
    super(name, label, 'simple', img, icon, disabled, hidden, notification, beta);
    path && (this.path = path);
    this.setActions(actions);
    this.setNotification(notification);
    this.setBeta(beta);
    this.setExternalLink(externalLink);
    this.setShowUpgrade(showUpgrade);
    this.setAdvancedItem(advanced);
  }

  public setActions(actions: string[]): void {
    if (actions && actions.length) {
      this.actions = actions;
    }
  }

  public setNotification(notification: boolean): void {
    if (notification) {
      this.notification = notification;
    }
  }

  public setBeta(beta: boolean): void {
    if (beta) {
      this.beta = beta;
    }
  }
  public setExternalLink(externalLink: boolean): void {
    if (externalLink) {
      this.externalLink = externalLink;
    }
  }
  public setShowUpgrade(showUpgrade: boolean): void {
    if (showUpgrade) {
      this.showUpgrade = showUpgrade;
    }
  }
  public setAdvancedItem(advanced: boolean): void {
    if (advanced) {
      this.advanced = advanced;
    }
  }

  public emitActions(): void {
   this.actions && this.actions.length && this.actions.forEach(action => ActionEmitterService.emitActions(action));
  }
}
